import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import { useSnackbar } from 'notistack';
import { editAttributesByEntityId } from "../../../../api's/DataModelApi";
import LoadingIcon from "../../../../reusable-component/LoadingIcon";

const dataTypeOptions = [
  "VARCHAR",
  "INTEGER",
  "TIMESTAMP",
  "BOOLEAN",
  "DATE",
  "FLOAT",
  "TEXT",
];

const EditAttributeModal = ({ open, onClose, attribute, entityId, onSuccess }) => {

  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [form, setForm] = useState({
    name: "",
    description: "",
    data_type: "VARCHAR",
    required_col: false,
    unique_col: false,
  });

  useEffect(() => {
    if (attribute) setForm(attribute);
  }, [attribute]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setLoading(true);

    const payload = {
      description: form.description,
      required_col: form.required_col,
      unique_col: form.unique_col,
    };

    try {
      const response = await editAttributesByEntityId(entityId, form.name, payload);
      if (response.status === 200) {
        setLoading(false);
        onClose();
        onSuccess?.();
      }
    } catch (error) {
      enqueueSnackbar('Something went wrong!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
          width: 500,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Edit Attribute
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Attribute Name"
              fullWidth
              size="small"
              value={form.name}
              disabled
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              label="Data Type"
              disabled
              fullWidth
              size="small"
              value={form.data_type}
              onChange={(e) => handleChange("data_type", e.target.value)}
            >
              {dataTypeOptions.map((dt) => (
                <MenuItem key={dt} value={dt}>
                  {dt}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Description"
              fullWidth
              size="small"
              value={form.description}
              onChange={(e) => handleChange("description", e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              select
              label="Required"
              fullWidth
              size="small"
              value={form.required_col}
              onChange={(e) =>
                handleChange("required_col", e.target.value === "true")
              }
            >
              <MenuItem value="true">true</MenuItem>
              <MenuItem value="false">false</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              select
              label="Unique"
              fullWidth
              size="small"
              value={form.unique_col}
              onChange={(e) =>
                handleChange("unique_col", e.target.value === "true")
              }
            >
              <MenuItem value="true">true</MenuItem>
              <MenuItem value="false">false</MenuItem>
            </TextField>
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </Box>
        {loading && <LoadingIcon />}
      </Box>
    </Modal>

  );
};

export default EditAttributeModal;
